import React from 'react';
import styles from './Dashboard.module.css';

const DashboardHeader = () => {
    return (
        <div className={styles.header}>
            <h1 className={styles.title}>Dashboard</h1>
            {/* <p className={styles.subtitle}>Welcome to CRO Portal</p> */}
        </div>
    );
};

export default DashboardHeader;